/**
 * PipelineFailureBanner — Dashboard top-strip degradation banner.
 *
 * v1.0 - W3-1-F1: pipeline-failure + data-stale signal display - 2026-07-02
 *
 * Renders banners returned by GET /api/banners (audience-filtered at API layer).
 * Stage-13 locked doc §5.5 + §9: consumer only — no PG write, no manifest emit.
 * §4.16: copy is operational; no money framing.
 * Kept independent from StaleBanner in KPICardGrid.tsx (§F1 scope — do not merge).
 */

import React from 'react';
import { Alert, AlertTitle, Box, Collapse } from '@mui/material';
import { Banner } from '../services/api';

interface PipelineFailureBannerProps {
  banners: Banner[];
}

const PipelineFailureBanner: React.FC<PipelineFailureBannerProps> = ({ banners }) => {
  if (!banners || banners.length === 0) return null;

  return (
    <Box sx={{ mb: 2 }}>
      {banners.map((banner) => (
        <Collapse in key={banner.key}>
          <Alert
            severity={banner.severity === 'error' ? 'error' : 'warning'}
            sx={{ mb: 1 }}
          >
            <AlertTitle>{banner.title}</AlertTitle>
            {banner.body}
          </Alert>
        </Collapse>
      ))}
    </Box>
  );
};

export default PipelineFailureBanner;
